import React from 'react';
import PropTypes from 'prop-types';
import { Card, Grid, makeStyles } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import InfoIcon from '@material-ui/icons/Info';
import { ProductStatus } from 'utils/enums/ProductsRequired';
import Tooltip from '@material-ui/core/Tooltip';

const styles = makeStyles((theme) => ({
    card: {
        height: '100px',
        marginBottom: '20px',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#f2f2f2'
        }
    },
    container: {
        height: '100%',
        display: 'flex',
        alignItems: 'center'
    },
    iconContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        '& img': {
            width: '50px',
            height: '50px'
        }
    },
    title: {
        color: theme.palette.primary.main,
        fontWeight: 'bold',
        fontSize: '1.3em'
    },
    description: {
        color: 'gray',
        fontSize: '1em'
    }
}));

function CardMultiSelectComponent(props) {
    const classes = new styles();
    const { list, onCardClick } = props;

    return (
        <React.Fragment>
            {list.map((element) => {
                return (
                    <Card key={element.id} className={classes.card} onClick={() => onCardClick(element)}>
                        <Grid container className={classes.container}>
                            <Grid item xs={4} className={classes.iconContainer}>
                                <img alt="" src={element.imgPath}></img>
                            </Grid>
                            <Grid item xs={6}>
                                <span className={classes.title}>{element.name}</span>
                            </Grid>
                            {element.status === ProductStatus.ACTIVE && (
                                <Grid item xs={2}>
                                    <CheckCircleIcon style={{ color: '#689F37' }} />
                                </Grid>
                            )}
                            {element.status === ProductStatus.ADDITION_PENDING && (
                                <Grid item xs={2}>
                                    <Tooltip title="Admin review pending" aria-label="add">
                                        <InfoIcon style={{ color: '#FFB300' }} />
                                    </Tooltip>
                                </Grid>
                            )}
                            {element.status === ProductStatus.DELETION_PENDING && (
                                <Grid item xs={2}>
                                    <Tooltip title="Admin review pending" aria-label="add">
                                        <InfoIcon style={{ color: '#FFB300' }} />
                                    </Tooltip>
                                </Grid>
                            )}
                            {element.status === ProductStatus.REJECTED && (
                                <Grid item xs={2}>
                                    <Tooltip title="Request rejected" aria-label="add">
                                        <InfoIcon style={{ color: '#C62828' }} />
                                    </Tooltip>
                                </Grid>
                            )}
                        </Grid>
                    </Card>
                );
            })}
        </React.Fragment>
    );
}

CardMultiSelectComponent.propTypes = {
    selectedEntities: PropTypes.array,
    setSelectedEntitites: PropTypes.func,
    list: PropTypes.array,
    onChange: PropTypes.func
};

export default CardMultiSelectComponent;
